import { truckerProfileApiService } from 'config/service';
import { urls } from 'constants/urls';
import { ITruckerProfileProps } from 'interfaces/profile.interface';
import { createSearchParams } from 'react-router-dom';

// eslint-disable-next-line
const createParams = (params: any) => `?${createSearchParams(params)}`;

const getTrucker = async (truckerId: string, freightId?: string): Promise<ITruckerProfileProps> => {
  const params = freightId ? createParams({ freightId }) : '';
  const res = await truckerProfileApiService.get<ITruckerProfileProps>(`${urls.trucker.profile}/${truckerId}${params}`);
  return res;
};

export { getTrucker };
